import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Footer from './footer';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
});

const Main = styled('div')({
  flexGrow: 1,
});

// ----------------------------------------------------------------------

export default function HomeLayout() {
  return (
    <StyledRoot>
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </StyledRoot>
  );
}
